// ============================================================
// VCS.Notify — Service Worker, Push, PWA-Install, Benachrichtigungen
// ============================================================
window.VCS = window.VCS || {};

VCS.Notify = class {

    // ── Konstanten ───────────────────────────────────────────

    static IOS_INSTALL_HINT_KEY = 'ios-install-hint-shown';
    static MAC_INSTALL_HINT_KEY = 'mac-install-hint-shown';
    static PWA_BANNER_DISMISSED_KEY = 'pwa-install-dismissed';
    static NOTIFY_DONT_ASK_KEY = 'notify-dont-ask';
    static ICON_PATH = '/all/webcfg/web-app-manifest-192x192.png';

    // ── Konstruktor ──────────────────────────────────────────

    constructor() {
        // View-Cache
        this._view = {
            btnInstall:          $('#btnInstall'),
            installHintBar:      $('#installHintBar'),
            installSettingsRow:  $('#installSettingsRow'),
            installSettingsHint: $('#installSettingsHint'),
            pwaInstallBanner:    $('#pwaInstallBanner'),
            pwaInstallBtn:       $('#pwaInstallBtn'),
            pwaInstallBannerMsg: $('#pwaInstallBannerMsg'),
            pwaInstallDismiss:   $('#pwaInstallDismiss'),
            btnNotify:           $('#btnNotify'),
            settingsNotifyToggle:$('#settingsNotifyToggle'),
            notifyStatus:        $('#notifyStatus'),
            tabCallNotifyStatus: $('#tabCallNotifyStatus'),
        };
    }

    // ── Service Worker ───────────────────────────────────────

    registerServiceWorker() {
        if (!('serviceWorker' in navigator)) {
            return;
        }
        // WICHTIG: nicht $(window).on('load', ...) benutzen — jQuery feuert
        // .on('load') NICHT rueckwirkend. Wenn init() nach bereits gefeuertem
        // window.load laeuft (z.B. weil loadTranslations() lange gedauert hat),
        // wuerde der Handler nie ausgeloest und sw.js nie registriert.
        const doRegister = () => {
            navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' })
                .then((reg) => {
                    console.log('[sw-debug] SW registriert, scope=' + reg.scope);
                    VCS.state._swRegOk = true;
                    if (VCS.state.chatMyPhone) {
                        this.notifySwPhone();
                    }
                })
                .catch(err => {
                    console.warn('Service Worker Registrierung fehlgeschlagen:', err);
                    VCS.state._swRegError = err.name + ': ' + err.message;
                });
        };
        if (document.readyState === 'complete') {
            doRegister();
        } else {
            window.addEventListener('load', doRegister, { once: true });
        }
    }

    notifySwPhone() {
        if (!VCS.state.chatMyPhone || !('serviceWorker' in navigator)) {
            return;
        }
        navigator.serviceWorker.ready.then(reg => {
            if (reg.active) {
                reg.active.postMessage({
                    type : 'set-phone',
                    phone: VCS.state.chatMyPhone,
                });
            }
        });
    }

    // ── Notification Prompt Dialog ───────────────────────────

    // Nach Registrierung aufrufen (kein "Nicht wieder fragen")
    promptAfterRegistration() {
        this._showNotifyPrompt(false);
    }

    // Beim App-Start aufrufen (mit "Nicht wieder fragen")
    promptOnAppStart() {
        if (localStorage.getItem(VCS.Notify.NOTIFY_DONT_ASK_KEY) === '1') {
            return;
        }
        this._showNotifyPrompt(true);
    }

    _showNotifyPrompt(showDontAsk) {
        if (!('Notification' in window) || !('PushManager' in window)) {
            return;
        }
        // Bereits denied → Dialog bringt nichts
        if (Notification.permission === 'denied') {
            return;
        }
        // Browser granted → App-Toggle automatisch aktivieren + Push setup
        if (Notification.permission === 'granted') {
            if (!VCS.state.notifyEnabled) {
                VCS.state.notifyEnabled = true;
                localStorage.setItem('notify-enabled', '1');
                this.updateNotifyButtonUI();
            }
            this.setupPushSubscription();
            return;
        }

        const $overlay  = $('#notifyPromptOverlay');
        const $allow    = $('#notifyPromptAllow');
        const $skip     = $('#notifyPromptSkip');
        const $dontAsk  = $('#notifyPromptDontAsk');
        const $checkbox = $('#notifyPromptDontAskCheck');
        if (!$overlay.length) {
            return;
        }

        $dontAsk.toggleClass('hidden', !showDontAsk);
        $checkbox.prop('checked', false);
        $overlay.removeClass('hidden');

        const cleanup = () => {
            $overlay.addClass('hidden');
            $allow.off('click');
            $skip.off('click');
            $overlay.off('click');
        };

        $allow.on('click', async () => {
            cleanup();
            // Browser-Permission holen falls noch nicht granted
            if (Notification.permission !== 'granted') {
                await Notification.requestPermission();
            }
            if (Notification.permission === 'granted') {
                VCS.state.notifyEnabled = true;
                localStorage.setItem('notify-enabled', '1');
                this.updateNotifyButtonUI();
                this.setupPushSubscription();
                VCS.ui?.showToast?.(t('notificationOn'), 'success');
            }
        });

        $skip.on('click', () => {
            if (showDontAsk && $checkbox.is(':checked')) {
                localStorage.setItem(VCS.Notify.NOTIFY_DONT_ASK_KEY, '1');
            }
            cleanup();
        });

        $overlay.on('click', (e) => {
            if (e.target === $overlay[0]) {
                if (showDontAsk && $checkbox.is(':checked')) {
                    localStorage.setItem(VCS.Notify.NOTIFY_DONT_ASK_KEY, '1');
                }
                cleanup();
            }
        });
    }

    // ── Push-Subscription ────────────────────────────────────

    async setupPushSubscription() {
        const _pushDbgBuffer = [];
        const _ua = VCS._errorLoggerUA || '?';
        const dbg = (msg) => {
            _pushDbgBuffer.push(msg);
            VCS.signaling?.send?.({ type: 'client-log', level: 'info', msg: '[push-debug] ' + msg, ua: _ua });
        };
        // Gepufferte Meldungen nachsenden sobald WebSocket bereit
        const flushDbg = () => {
            if (_pushDbgBuffer.length && VCS.signaling?.send) {
                _pushDbgBuffer.forEach(m => {
                    VCS.signaling.send({ type: 'client-log', level: 'info', msg: '[push-debug] ' + m, ua: _ua });
                });
            }
        };
        VCS.state._pushDbgFlush = flushDbg;
        if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
            dbg('Abbruch: serviceWorker oder PushManager nicht verfuegbar');
            return;
        }
        if (Notification.permission !== 'granted') {
            dbg('Abbruch: Notification.permission=' + Notification.permission);
            return;
        }
        const vapidKey = window.VAPID_PUBLIC_KEY;
        if (!vapidKey) {
            dbg('Abbruch: VAPID_PUBLIC_KEY leer');
            return;
        }
        try {
            const swReg = navigator.serviceWorker.controller
                ? 'controller=' + navigator.serviceWorker.controller.state
                : 'no-controller';
            const regs = await navigator.serviceWorker.getRegistrations();
            dbg('SW ready warten... ' + swReg + ' regs=' + regs.length +
                (regs[0] ? ' active=' + !!regs[0].active + ' installing=' + !!regs[0].installing + ' waiting=' + !!regs[0].waiting : ''));
            const reg = await Promise.race([
                navigator.serviceWorker.ready,
                new Promise((_, reject) => setTimeout(() => reject(new Error('SW ready timeout 10s')), 10000))
            ]);
            dbg('SW ready, getSubscription...');
            let sub = await reg.pushManager.getSubscription();
            if (!sub) {
                dbg('Keine bestehende Sub, subscribe...');
                sub = await reg.pushManager.subscribe({
                    userVisibleOnly     : true,
                    applicationServerKey: this._urlBase64ToUint8Array(vapidKey),
                });
                dbg('Subscribe erfolgreich, endpoint=' + sub.endpoint.substring(0, 60) + '...');
            } else {
                dbg('Bestehende Sub gefunden, endpoint=' + sub.endpoint.substring(0, 60) + '...');
            }
            VCS.state.pushSubscription = sub;
            this.sendPushSubscription();
            dbg('Subscription an Server gesendet');
        } catch (e) {
            dbg('FEHLER: ' + e.name + ': ' + e.message);
        }
    }

    sendPushSubscription() {
        // Vor dem Login KEINE Push-Registrierung an den Server senden -- sonst
        // landet eine verwaiste Subscription mit phone=? beim Server. Nach dem
        // Login ruft setupPushSubscription (promptAfterRegistration etc.) dies
        // erneut auf, dann greift die Registrierung mit gueltiger Identitaet.
        if (!VCS.state.chatRegistered) {
            return;
        }
        if (!VCS.state.pushSubscription || !VCS.state.myId) {
            return;
        }
        VCS.signaling?.send?.({
            type        : 'push-subscribe',
            id          : VCS.state.myId,
            subscription: VCS.state.pushSubscription.toJSON(),
            quiet       : !!VCS.state.quietMode,
        });
    }

    // ── Ruhemodus ────────────────────────────────────────────

    // Gilt nur fuer diese Installation. Der Server sendet dann keine Pushes
    // mehr an diese clientId; in der offenen App unterdruecken die Aufrufer
    // von isQuiet() Klingeln und Meldungen.
    isQuiet() {
        return !!VCS.state.quietMode;
    }

    setQuietMode(on) {
        VCS.state.quietMode = !!on;
        try {
            localStorage.setItem('quiet-mode', on ? '1' : '0');
        } catch (_) {}
        this.syncQuietMode();
        this.updateQuietModeUI();
        console.log('[quiet] Ruhemodus ' + (on ? 'an' : 'aus'));
    }

    // Stand an den Server melden. Nach jedem chat-authed erneut, falls der
    // Schalter offline umgelegt wurde.
    syncQuietMode() {
        // Server prueft selbst, ob der Socket eingeloggt ist
        if (!VCS.state.myId) {
            return;
        }
        VCS.signaling?.send?.({
            type : 'push-quiet',
            id   : VCS.state.myId,
            quiet: !!VCS.state.quietMode,
        });
    }

    updateQuietModeUI() {
        const on = !!VCS.state.quietMode;
        $('#settingsQuietToggle').prop('checked', on);
        $('#quietModeIndicator').toggleClass('hidden', !on);
    }

    // ── Install UX (PWA) ─────────────────────────────────────

    updateInstallButtonUI() {
        const visible = !!VCS.state.deferredInstallPrompt;
        this._view.btnInstall.toggleClass('hidden', !visible);
        this._view.installHintBar.toggleClass('hidden', !visible);
        this._updatePwaBanner();
    }

    _updatePwaBanner() {
        if (this._isStandalone()
            || localStorage.getItem(VCS.Notify.PWA_BANNER_DISMISSED_KEY)) {
            this._view.pwaInstallBanner.addClass('hidden');
            return;
        }

        if (VCS.state.deferredInstallPrompt) {
            // Chrome/Edge: show install button
            this._view.pwaInstallBannerMsg.text(t('installHint'));
            this._view.pwaInstallBtn.text(t('installApp')).removeClass('hidden');
            this._view.pwaInstallBanner.removeClass('hidden');
        } else if (this._isIOS()) {
            this._view.pwaInstallBannerMsg.text(t('iosInstallHint'));
            this._view.pwaInstallBtn.addClass('hidden');
            this._view.pwaInstallBanner.removeClass('hidden');
        } else if (this._isMacSafari()) {
            this._view.pwaInstallBannerMsg.text(t('macInstallHint'));
            this._view.pwaInstallBtn.addClass('hidden');
            this._view.pwaInstallBanner.removeClass('hidden');
        }
    }

    _dismissPwaBanner() {
        this._view.pwaInstallBanner.addClass('hidden');
        localStorage.setItem(VCS.Notify.PWA_BANNER_DISMISSED_KEY, '1');
    }

    setupInstallUX() {
        // Settings install button (Chrome/Edge)
        this._view.btnInstall.on('click', async () => {
            if (!VCS.state.deferredInstallPrompt) {
                return;
            }
            VCS.state.deferredInstallPrompt.prompt();
            try {
                await VCS.state.deferredInstallPrompt.userChoice;
            } catch (_) {}
            VCS.state.deferredInstallPrompt = null;
            this.updateInstallButtonUI();
        });

        $(window).on('beforeinstallprompt', (e) => {
            e.originalEvent.preventDefault();
            VCS.state.deferredInstallPrompt = e.originalEvent;
            this.updateInstallButtonUI();
        });

        $(window).on('appinstalled', () => {
            VCS.state.deferredInstallPrompt = null;
            this._dismissPwaBanner();
            this.updateInstallButtonUI();
            VCS.ui?.showToast?.(t('appInstalled'), 'success');
        });

        // Main page banner: install button click
        this._view.pwaInstallBtn.on('click', async () => {
            if (!VCS.state.deferredInstallPrompt) {
                return;
            }
            VCS.state.deferredInstallPrompt.prompt();
            try {
                await VCS.state.deferredInstallPrompt.userChoice;
            } catch (_) {}
            VCS.state.deferredInstallPrompt = null;
            this.updateInstallButtonUI();
        });

        // "Don't show again" checkbox
        this._view.pwaInstallDismiss.on('change', () => {
            if (this._view.pwaInstallDismiss.is(':checked')) {
                this._dismissPwaBanner();
            }
        });

        // Show banner (respects dismissed state)
        this._updatePwaBanner();

        // Persistent install hint in Settings for Safari (iOS + macOS)
        if (!this._isStandalone()) {
            if (this._isIOS()) {
                this._view.installSettingsHint.text(t('iosInstallHint'));
                this._view.installSettingsRow.removeClass('hidden');
            } else if (this._isMacSafari()) {
                this._view.installSettingsHint.text(t('macInstallHint'));
                this._view.installSettingsRow.removeClass('hidden');
            }
        }
    }

    // ── Notify-Button & Benachrichtigungen ───────────────────

    updateNotifyButtonUI() {
        const allowed = VCS.state.notifyEnabled
            && 'Notification' in window
            && Notification.permission === 'granted';

        this._view.settingsNotifyToggle.prop('checked', allowed);

        if (!this._view.btnNotify.length) {
            return;
        }

        VCS.ui?.setButtonIcon?.('btnNotify', allowed ? 'notifyOn' : 'notifyOff');
        this._view.btnNotify
            .toggleClass('btn-active-red', !allowed)
            .attr('title', t(allowed ? 'notificationOn' : 'notificationOff'));

        const iconHtml = allowed ? VCS.ui?.ICONS?.bell : VCS.ui?.ICONS?.bellOff;
        [this._view.notifyStatus, this._view.tabCallNotifyStatus].forEach(($el) => {
            if (!$el.length) {
                return;
            }
            if (!('Notification' in window)) {
                $el.addClass('hidden');
                return;
            }
            $el.removeClass('hidden notify-status-icon--on notify-status-icon--off')
               .html(iconHtml || '')
               .addClass(allowed ? 'notify-status-icon--on' : 'notify-status-icon--off')
               .attr('title', t(allowed ? 'notificationOn' : 'notificationOff'))
               .css('cursor', allowed ? 'default' : 'pointer');
        });
    }

    async handleNotifyToggle() {
        if (Notification.permission === 'granted') {
            VCS.state.notifyEnabled = !VCS.state.notifyEnabled;
            localStorage.setItem('notify-enabled', VCS.state.notifyEnabled ? '1' : '0');
            this.updateNotifyButtonUI();
            VCS.ui?.showToast?.(t(VCS.state.notifyEnabled ? 'notificationOn' : 'notificationOff'), 'info');
            return;
        }
        if (Notification.permission === 'denied') {
            VCS.ui?.showToast?.(t('notificationBlocked'), 'warning');
            return;
        }
        const perm = await Notification.requestPermission();
        VCS.state.notifyEnabled = perm === 'granted';
        localStorage.setItem('notify-enabled', VCS.state.notifyEnabled ? '1' : '0');
        this.updateNotifyButtonUI();
        VCS.ui?.showToast?.(
            t(VCS.state.notifyEnabled ? 'notificationOn' : 'notificationBlocked'),
            VCS.state.notifyEnabled ? 'success' : 'warning'
        );
        if (VCS.state.notifyEnabled) {
            this.setupPushSubscription();
        }
    }

    maybeNotifyJoinRequest(guestName) {
        if (!document.hidden) {
            return;
        }
        if (!VCS.state.notifyEnabled) {
            return;
        }
        if (!('Notification' in window) || Notification.permission !== 'granted') {
            return;
        }
        if (VCS.state.activeJoinNotification) {
            VCS.state.activeJoinNotification.close();
            VCS.state.activeJoinNotification = null;
        }
        const body = `${guestName} ${t('wantsToJoin')}`;
        VCS.state.activeJoinNotification = new Notification(t('joinRequest'), {
            body,
            tag : 'join-request',
            icon: VCS.Notify.ICON_PATH,
        });
        VCS.state.activeJoinNotification.onclick = () => window.focus();
    }

    // ── App Badge ────────────────────────────────────────────

    // Wird vom Signaling-Handler (badge-update) und von der Chat-Liste beim
    // Initial-Load aufgerufen. Silent-Fallback auf Browsern ohne Badging API.
    applyBadge(count) {
        const n = (typeof count === 'number' && count >= 0) ? count : 0;
        try {
            if (n > 0 && navigator.setAppBadge) {
                navigator.setAppBadge(n);
            } else if (navigator.clearAppBadge) {
                navigator.clearAppBadge();
            }
        } catch (_) {}
    }

    // ── Init ─────────────────────────────────────────────────

    init() {
        this.registerServiceWorker();
        this.setupInstallUX();
        this._listenSwMessages();
        this.updateQuietModeUI();

        if (!('Notification' in window)) {
            this._view.btnNotify.addClass('hidden');
            return;
        }

        this._view.btnNotify.on('click', () => this.handleNotifyToggle());
        [this._view.notifyStatus, this._view.tabCallNotifyStatus].forEach(($el) => {
            $el.on('click', () => this.handleNotifyToggle());
        });

        // Push-Subscription automatisch (wieder-)herstellen wenn Permission bereits granted
        if (Notification.permission === 'granted') {
            this.setupPushSubscription();
        }
    }

    // Service-Worker postMessage empfangen (z.B. Incoming-Call via Push)
    _listenSwMessages() {
        if (!('serviceWorker' in navigator)) {
            return;
        }

        // Nachrichten vom SW empfangen
        navigator.serviceWorker.addEventListener('message', (event) => {
            const data = event.data;
            if (!data) {
                return;
            }
            if (data.type === 'incoming-call-push') {
                if (!VCS.state.chatRegistered) {
                    return;
                }
                this._handleIncomingCallPush(data);
            } else if (data.type === 'call-handled-elsewhere') {
                // Anderes Geraet hat Call angenommen/abgelehnt — Overlay schliessen
                document.querySelector('.incoming-call-overlay')?.remove();
            } else if (data.type === 'account-wipe-done') {
                // Account wurde auf einem anderen Geraet geloescht. SW hat
                // bereits Caches + IndexedDB entfernt; wir muessen nur noch
                // localStorage/sessionStorage loeschen und neu laden.
                console.warn('[notify] account-wipe received, dropping local state');
                VCS.state._accountKicked = true;
                (async () => {
                    try {
                        await VCS.session?.clearAllClientData();
                    } catch (_) {}
                    try {
                        if (window.location.pathname !== '/' && !window.location.pathname.endsWith('/index.php')) {
                            window.location.href = '/';
                        } else {
                            window.location.reload();
                        }
                    } catch (_) {
                        window.location.reload();
                    }
                })();
            }
        });

        // Wenn App sichtbar wird → SW nach pending Call fragen
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') {
                this._checkPendingCall();
            }
        });

        // Auch direkt beim Laden prüfen (openWindow hat keinen visibilitychange)
        navigator.serviceWorker.ready.then(() => this._checkPendingCall());

        // URL-Parameter prüfen (Fallback wenn SW den Call per openWindow mit Params öffnet)
        this._checkUrlCallParams();
    }

    _checkUrlCallParams() {
        const params = new URLSearchParams(window.location.search);
        if (params.get('incomingCall') !== '1') {
            return;
        }
        if (!VCS.state.chatRegistered) {
            // URL bereinigen, aber keinen Call-Dialog zeigen
            history.replaceState(null, '', window.location.pathname);
            return;
        }
        const callId      = params.get('callId');
        const callerName  = params.get('callerName');
        const callerPhone = params.get('callerPhone');
        const callType    = params.get('callType') || 'video';
        if (callId) {
            // URL bereinigen (Parameter entfernen)
            const cleanUrl = window.location.pathname;
            history.replaceState(null, '', cleanUrl);
            // Dialog anzeigen
            this._handleIncomingCallPush({ callId, callerName, callerPhone, callType });
        }
    }

    _handleIncomingCallPush(data) {
        if (this.isQuiet()) {
            console.log('[quiet] Anruf-Push ignoriert: ' + data.callId);
            return;
        }
        VCS.chatContacts?.showIncomingCallToast({
            callId     : data.callId,
            callerName : data.callerName,
            callerPhone: data.callerPhone,
            callType   : data.callType,
        });
    }

    _checkPendingCall() {
        if (!VCS.state.chatRegistered) {
            return;
        }
        if (!('serviceWorker' in navigator) || !navigator.serviceWorker.controller) {
            return;
        }
        navigator.serviceWorker.controller.postMessage({ type: 'check-pending-call' });
    }

    // ── Private Methoden ─────────────────────────────────────

    _isIOS() {
        return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    }

    _isMacSafari() {
        const ua = navigator.userAgent;
        return /Macintosh/.test(ua) && /Safari/.test(ua) && !/Chrome/.test(ua);
    }

    _isStandalone() {
        return window.matchMedia('(display-mode: standalone)').matches
            || window.navigator.standalone === true;
    }

    _urlBase64ToUint8Array(base64String) {
        const padding = '='.repeat((4 - base64String.length % 4) % 4);
        const base64  = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
        const rawData = atob(base64);
        return Uint8Array.from([...rawData].map(c => c.charCodeAt(0)));
    }
};
